import { render, staticRenderFns } from "./SnapshotTable.vue?vue&type=template&id=6d7fdc8d&"
import script from "./SnapshotTable.vue?vue&type=script&lang=js&"
export * from "./SnapshotTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7fdc8d')) {
      api.createRecord('6d7fdc8d', component.options)
    } else {
      api.reload('6d7fdc8d', component.options)
    }
    module.hot.accept("./SnapshotTable.vue?vue&type=template&id=6d7fdc8d&", function () {
      api.rerender('6d7fdc8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/reports/SnapshotTable.vue"
export default component.exports